import { format } from 'date-fns';
import { EventSitemap, HostSitemap, makeEventPageLink, makeHostPageLink } from '@sweatpals/shared';

export const SITEMAP_INDEX = 'index.xml';

export const SITEMAP_DATE_FORMAT = "yy_MM_dd'.xml'";

export const SITEMAP_PAGE_FORMAT = 'sitemap_page_(?<pageNumber>\\d+).xml';
export const createSitemapPageFormat = (page: number) => `sitemap_page_${page}.xml`;
export const getPageNumberFromPageFormat = (sitemapStr: string) => {
	const match = sitemapStr.match(SITEMAP_PAGE_FORMAT);

	if (!match) {
		return 1;
	}

	const pageNumber =
		!match.groups || isNaN(Number(match.groups?.pageNumber)) || Number(match.groups?.pageNumber) <= 0
			? 1
			: Number(match.groups?.pageNumber);

	return pageNumber;
};

export const HOSTS_PAGE_SIZE = 500;

// events

export const generateEventsIndexSitemap = (eventDates: Date[] = []): string => `<?xml version="1.0" encoding="UTF-8"?>
<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
	${eventDates
		.map(
			(date) => `
	<sitemap>
		<loc>http://www.sweatpals.com/events/sitemaps/${format(date, SITEMAP_DATE_FORMAT)}</loc>
		<lastmod>${new Date().toISOString()}</lastmod>
	</sitemap>`
		)
		.join('\n')}
</sitemapindex>
`;

export const generateEventInstancesSitemap = (
	events: EventSitemap[] = []
): string => `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
	${events
		.map(
			({ alias, shortLocalInstance, lastMod }) => `
	<url>
		<loc>https://www.sweatpals.com/${makeEventPageLink({ eventAlias: alias, shortLocalInstance })}</loc>
		<lastmod>${lastMod}</lastmod>
		<changefreq>daily</changefreq>
	</url>`
		)
		.join('\n')}
</urlset>
`;

// hosts

export const generateHostsIndexSitemap = (pagesCount: number) => `<?xml version="1.0" encoding="UTF-8"?>
<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
	${Array.from({ length: pagesCount }).map(
		(_, index) => `
	<sitemap>
		<loc>http://www.sweatpals.com/hosts/sitemaps/${createSitemapPageFormat(index + 1)}</loc>
		<lastmod>${new Date().toISOString()}</lastmod>
	</sitemap>`
	).join('\n')}
</sitemapindex>
`;

export const generateHostsSitemap = (sitemaps: HostSitemap[] = []): string => `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
	${sitemaps.map(
		(sitemap) => `
	<url>
		<loc>https://www.sweatpals.com/${makeHostPageLink({
			userName: sitemap.userName,
		})}</loc>
		<lastmod>${sitemap.lastMod}</lastmod>
		<changefreq>daily</changefreq>
	</url>`
	).join('\n')}
</urlset>
`;
